import clsx from "clsx";
import { Children, ReactNode, useId, useState } from "react";
import { twMerge } from "tailwind-merge";

const Tabs = ({
  tabs,
  className = "",
  tabClassName = "",
  tabControlClassName = "",
  children,
}: {
  tabs: string[];
  className?: string;
  tabClassName?: string;
  tabControlClassName?: string;
  children: ReactNode | ReactNode[];
}) => {
  const [activeTab, setActiveTab] = useState<number>(0);
  const id = useId();

  const heads =
    tabs.length > 0 &&
    tabs.map((tab, index) => (
      <button
        key={`tab-${id}-${index}`}
        role="tab"
        className={twMerge(
          clsx(
            `col-start-${index} row-start-1`,
            "tab tab-lifted tab-bordered",
            {
              "tab-active": activeTab === index,
            },
            tabClassName
          )
        )}
        onClick={() => setActiveTab(index)}
      >
        {tab}
      </button>
    ));

  return (
    <div className="flex flex-col justify-center w-full">
      <div
        role="tablist"
        className={twMerge(
          clsx(
            `justify-center items-center align-middle`,
            "tabs tabs-boxed flex flex-col w-full",
            className
          )
        )}
      >
        {tabs.length > 0 && (
          <div
            className={twMerge(
              clsx(
                "flex justify-center items-center gap-2",
                tabControlClassName
              )
            )}
          >
            {heads}
          </div>
        )}

        {Children.map(children, (child, index) => {
          return (
            <>
              <div
                key={`tab-content-${id}-${index}`}
                className={twMerge(
                  clsx(
                    "w-full text-justify align-middle tab-content",
                    {
                      block: index === activeTab,
                    },
                    `col-span-${tabs.length}`
                  )
                )}
              >
                {Children.toArray(child).map((c) => c)}
              </div>
            </>
          );
        })}
      </div>
    </div>
  );
};
export default Tabs;
